/**
 * Audit Model
 * Manages tracking data access logs, modifications, and deletions in the audit_logs collection.
 * Required for FDA 21 CFR Part 11 and healthcare security audits.
 */

import { collection, addDoc } from 'firebase/firestore';
import { db, auth } from '../firebase.js';

const AUDIT_COLL = 'audit_logs';

/**
 * Record a new action audit trail log entry
 * @param {'CREATE'|'UPDATE'|'DELETE'|'LOGIN'|'LOGOUT'} action 
 * @param {string} entityType - e.g. 'doctors', 'sales', 'investments'
 * @param {string} targetId - affected doc ID
 * @param {object} details - details object of changed fields
 * @returns {Promise<void>}
 */
export async function writeAuditLog(action, entityType, targetId, details = {}) {
  try {
    const currentUser = auth.currentUser;
    const userId = currentUser ? currentUser.uid : 'SYSTEM_SEEDED';
    const userEmail = currentUser ? currentUser.email : 'system@aurapharma.com';

    const payload = {
      userId,
      userEmail,
      action,
      entityType,
      targetId,
      timestamp: new Date().toISOString(),
      details: JSON.stringify(details)
    };

    await addDoc(collection(db, AUDIT_COLL), payload);
  } catch (err) {
    // Fail silently in terms of UI crash, but print warning
    console.error("Audit Logger Error:", err);
  }
}
